import { DashboardSelectOptionType } from "@/enums/enums";

export function GetCustomDashboardTemplate(customDashboardDetail: any = null) {
  const customDashboardTemplate = {
    id: customDashboardDetail ? customDashboardDetail.id : 0,
    number: {
      value: customDashboardDetail ? customDashboardDetail.number : "",
      validateError: false,
    },
    name: {
      value: customDashboardDetail ? customDashboardDetail.name : "",
      validateError: false,
    },
    customDashboardType: {
      value: customDashboardDetail ? customDashboardDetail.customDashboardType : 1,
    },
    description: {
      value: customDashboardDetail ? customDashboardDetail.description : "",
      validateError: false,
    },
    file: {
      fileName: "",
      rawString: "",
      fileType: "",
      fileUrl: customDashboardDetail ? customDashboardDetail.imageUrl : "",
    },
  };

  return customDashboardTemplate;
}

export function ValidateCustomDashboardTemplate(customDashboardTemplate: any) {
  const numberValidateError =
    customDashboardTemplate.number.value == "" || customDashboardTemplate.number.validateError;
  const nameValidateError = customDashboardTemplate.name.value == "" || customDashboardTemplate.name.validateError;
  const descriptionValidateError = customDashboardTemplate.description.validateError;

  if (!numberValidateError && !nameValidateError && !descriptionValidateError) {
    return true;
  } else {
    customDashboardTemplate.number.validateError = numberValidateError;
    customDashboardTemplate.name.validateError = nameValidateError;
    customDashboardTemplate.description.validateError = descriptionValidateError;
    return false;
  }
}

export function ConvertToCustomDashboardModel(customDashboardTemplate: any) {
  const customDashboardModel = {
    id: customDashboardTemplate.id,
    number: customDashboardTemplate.number.value,
    name: customDashboardTemplate.name.value,
    customDashboardType: customDashboardTemplate.customDashboardType.value,
    description: customDashboardTemplate.description.value,
    isUpload: customDashboardTemplate.isUpload ? true : false,
    file: {
      fileName: customDashboardTemplate.file.fileName,
      rawString: customDashboardTemplate.file.rawString,
      fileUrl: "",
      fileType: customDashboardTemplate.file.fileType,
    },
  };

  return customDashboardModel;
}

export function ConvertToCustomDashboardGroupModel(allocationId: number, customDashboardGroupList: any) {
  const customDashboardGroupTemplate = {
    allocationId: allocationId,
    allocationItemGroupList: [] as any,
  };

  if (customDashboardGroupList && customDashboardGroupList.length > 0) {
    customDashboardGroupList.forEach((_customDashboardGroup: any) => {
      const customDashboardGroup = {
        name: _customDashboardGroup.name,
        allocationItemGroupType: _customDashboardGroup.type,
        allocationItemList: [] as any,
      };
      _customDashboardGroup.allocationItemList.forEach((_allocationItem: any) => {
        customDashboardGroup.allocationItemList.push({ allocationItemId: _allocationItem.allocationItemId });
      });

      customDashboardGroupTemplate.allocationItemGroupList.push(customDashboardGroup);
    });
  }

  return customDashboardGroupTemplate;
}

export function GetAllocationMockup() {
  return [
    { name: "ร้านรัชดาภิเษก", iconType: "icon-allocation15", color: "rgb(249, 63, 68)", allocationItemId: 478 },
    { name: "ร้านสุขุมวิท", iconType: "icon-allocation15", color: "rgb(246, 194, 44)", allocationItemId: 479 },
    { name: "ร้านสีลม", iconType: "icon-allocation15", color: "rgb(118, 182, 168)", allocationItemId: 488 },
    { name: "ร้านบางบัวทอง", iconType: "icon-allocation15", color: "rgb(255, 150, 73)", allocationItemId: 671 },
  ];
}

export function GetProductMockup() {
  return [
    { name: "P00001 สินค้าทดสอบ 1", id: 31719 },
    { name: "P00002 สินค้าทดสอบ 2", id: 31720 },
    { name: "P00003 สินค้าทดสอบ 3", id: 31721 },
    { name: "P00004 สินค้าทดสอบ 4", id: 31739 },
  ];
}

export function GetContactMockup() {
  return [
    { contactShortName: "C00001 ผู้ขายสินค้า (บจก.)", id: 58277 },
    { contactShortName: "C00002 ลูกค้าทั่วไป (บุคคลธรรมดา)", id: 58278 },
    { contactShortName: "C00003 พื้นที่ขายของ (บจก.)", id: 58279 },
    { contactShortName: "C00004 ดูแลทำความสะอาด (บจก.)", id: 58280 },
    { contactShortName: "C00005 พนักงานขาย (ค่าคอม) (บุคคลธรรมดา)", id: 58282 },
  ];
}

export function GetCustomDashboardCompareMockup(dashboardSelectOptionType: DashboardSelectOptionType) {
  const thisMonth = {
    customDashBoardId: 58,
    allocationId: 217,
    customDashboardGroup: {
      id: "60c6d7206aaaef5e9c9afb06",
      merchantId: 2788,
      createdDateTime: "2021-06-14T04:12:16.477Z",
      createdUserId: 2867,
      customDashboardId: 58,
      allocationId: 217,
      allocationItemGroupList: [
        {
          name: "ร้านรัชดาภิเษก",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 478,
            },
          ],
        },
        {
          name: "ร้านสุขุมวิท",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 479,
            },
          ],
        },
        {
          name: "ร้านสีลม",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 488,
            },
          ],
        },
        {
          name: "ร้านบางบัวทอง",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 671,
            },
          ],
        },
      ],
    },
    dashboardSelectOptionType: 1,
    fromDate: "2021-12-01T00:00:00",
    toDate: "2021-12-31T00:00:00",
    profitLossList: [
      {
        allocationItemGroup: {
          name: "ร้านรัชดาภิเษก",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 478,
            },
          ],
        },
        revenueTotal: 47998,
        costOfSalesAndServicesTotal: 29664,
        grossProfitLossTotal: 18334,
        sellingExpensesTotal: 960,
        administrativeExpenseTotal: 11600,
        otherExpensesTotal: 0,
        netOperatingProfitLossBeforeInterestAndTaxTotal: 5774,
        interestExpenseTotal: 0,
        incomeTaxTotal: 0,
        profitTotal: 5774,
        allocationAccountList: [
          {
            accountId: 101,
            total: 29664,
          },
          {
            accountId: 88,
            total: 47998,
          },
          {
            accountId: 108,
            total: 960,
          },
          {
            accountId: 201,
            total: 0,
          },
          {
            accountId: 160,
            total: 4500,
          },
          {
            accountId: 148,
            total: 7100,
          },
        ],
      },
      {
        allocationItemGroup: {
          name: "ร้านสุขุมวิท",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 479,
            },
          ],
        },
        revenueTotal: 120000,
        costOfSalesAndServicesTotal: 72000,
        grossProfitLossTotal: 48000,
        sellingExpensesTotal: 1200,
        administrativeExpenseTotal: 36220,
        otherExpensesTotal: 0,
        netOperatingProfitLossBeforeInterestAndTaxTotal: 10580,
        interestExpenseTotal: 0,
        incomeTaxTotal: 0,
        profitTotal: 10580,
        allocationAccountList: [
          {
            accountId: 101,
            total: 72000,
          },
          {
            accountId: 88,
            total: 120000,
          },
          {
            accountId: 157,
            total: 19600,
          },
          {
            accountId: 173,
            total: 4120,
          },
          {
            accountId: 108,
            total: 1200,
          },
          {
            accountId: 201,
            total: 0,
          },
          {
            accountId: 160,
            total: 4500,
          },
          {
            accountId: 148,
            total: 8000,
          },
        ],
      },
      {
        allocationItemGroup: {
          name: "ร้านสีลม",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 488,
            },
          ],
        },
        revenueTotal: 102705,
        costOfSalesAndServicesTotal: 82665,
        grossProfitLossTotal: 20040,
        sellingExpensesTotal: 1025,
        administrativeExpenseTotal: 20093,
        otherExpensesTotal: 0,
        netOperatingProfitLossBeforeInterestAndTaxTotal: -1078,
        interestExpenseTotal: 0,
        incomeTaxTotal: 0,
        profitTotal: -1078,
        allocationAccountList: [
          {
            accountId: 101,
            total: 82665,
          },
          {
            accountId: 88,
            total: 102705,
          },
          {
            accountId: 108,
            total: 1025,
          },
          {
            accountId: 201,
            total: 0,
          },
          {
            accountId: 160,
            total: 2593,
          },
          {
            accountId: 148,
            total: 14000,
          },
          {
            accountId: 173,
            total: 3500,
          },
        ],
      },
      {
        allocationItemGroup: {
          name: "ร้านบางบัวทอง",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 671,
            },
          ],
        },
        revenueTotal: 221840,
        costOfSalesAndServicesTotal: 150400,
        grossProfitLossTotal: 71440,
        sellingExpensesTotal: 2218,
        administrativeExpenseTotal: 38000,
        otherExpensesTotal: 8500,
        netOperatingProfitLossBeforeInterestAndTaxTotal: 22722,
        interestExpenseTotal: 0,
        incomeTaxTotal: 0,
        profitTotal: 22722,
        allocationAccountList: [
          {
            accountId: 101,
            total: 150400,
          },
          {
            accountId: 88,
            total: 221840,
          },
          {
            accountId: 108,
            total: 2218,
          },
          {
            accountId: 201,
            total: 8500,
          },
          {
            accountId: 160,
            total: 14000,
          },
          {
            accountId: 148,
            total: 24000,
          },
        ],
      },
    ],
    revenue: {
      total: 492543,
      changeVaue: 2031.9,
      changeFormType: 3,
      productTop1Id: 31739,
      productTop2Id: 31719,
      productTop3Id: 31721,
      productTop1Total: 221840,
      productTop2Total: 120000,
      productTop3Total: 102705,
      productOtherTotal: 47998,
      productTop1ChangeValue: 2111.76,
      productTop2ChangeValue: 2400,
      productTop3ChangeValue: 2031.91,
      contactTop1Total: 492543,
      contactTop2Total: 0,
      contactTop3Total: 0,
      contactTop1Id: 58278,
      contactTop2Id: 0,
      contactTop3Id: 0,
      contactOtherTotal: 0,
      contactTop1ChangeValue: 2031.9,
      contactTop2ChangeValue: 0,
      contactTop3ChangeValue: 0,
      accountTop1Id: 88,
      accountTop2Id: 0,
      accountTop3Id: 0,
      accountTop1Total: 492543,
      accountTop2Total: 0,
      accountTop3Total: 0,
      accountOtherTotal: 0,
      accountTop1ChangeValue: 2031.9,
      accountTop2ChangeValue: 0,
      accountTop3ChangeValue: 0,
    },
    expense: {
      total: 454545,
      changeVaue: 2099.96,
      changeFormType: 3,
      productTop1Id: 31739,
      productTop2Id: 31721,
      productTop3Id: 31719,
      productTop1Total: 150400,
      productTop2Total: 82665,
      productTop3Total: 72000,
      productOtherTotal: 149480,
      productTop1ChangeValue: 2111.76,
      productTop2ChangeValue: 2031.91,
      productTop3ChangeValue: 2400,
      contactTop1Total: 334729,
      contactTop2Total: 78693,
      contactTop3Total: 27220,
      contactTop1Id: 58278,
      contactTop2Id: 58279,
      contactTop3Id: 58280,
      contactOtherTotal: 13903,
      contactTop1ChangeValue: 2010.32,
      contactTop2ChangeValue: 1000,
      contactTop3ChangeValue: 467.08,
      accountTop1Id: 101,
      accountTop2Id: 148,
      accountTop3Id: 160,
      accountTop1Total: 334729,
      accountTop2Total: 53100,
      accountTop3Total: 25593,
      accountOtherTotal: 41123,
      accountTop1ChangeValue: 2010.32,
      accountTop2ChangeValue: 1000,
      accountTop3ChangeValue: 1000,
      accountExpenseTypeTop1Id: 1,
      accountExpenseTypeTop2Id: 3,
      accountExpenseTypeTop3Id: 4,
      accountExpenseTypeTop1Total: 334729,
      accountExpenseTypeTop2Total: 105913,
      accountExpenseTypeTop3Total: 8500,
      accountExpenseTypeOtherTotal: 5403,
      accountExpenseTypeTop1ChangeValue: 2010.32,
      accountExpenseTypeTop2ChangeValue: 2106.52,
      accountExpenseTypeTop3ChangeValue: 1000,
    },
  };
  const lastMonth = {
    customDashBoardId: 58,
    allocationId: 217,
    customDashboardGroup: {
      id: "60c6d7206aaaef5e9c9afb06",
      merchantId: 2788,
      createdDateTime: "2021-06-14T04:12:16.477Z",
      createdUserId: 2867,
      customDashboardId: 58,
      allocationId: 217,
      allocationItemGroupList: [
        {
          name: "ร้านรัชดาภิเษก",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 478,
            },
          ],
        },
        {
          name: "ร้านสุขุมวิท",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 479,
            },
          ],
        },
        {
          name: "ร้านสีลม",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 488,
            },
          ],
        },
        {
          name: "ร้านบางบัวทอง",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 671,
            },
          ],
        },
      ],
    },
    dashboardSelectOptionType: 1,
    fromDate: "2021-11-01T00:00:00",
    toDate: "2021-11-30T00:00:00",
    profitLossList: [
      {
        allocationItemGroup: {
          name: "ร้านรัชดาภิเษก",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 478,
            },
          ],
        },
        revenueTotal: 42336,
        costOfSalesAndServicesTotal: 28224,
        grossProfitLossTotal: 14112,
        sellingExpensesTotal: 846,
        administrativeExpenseTotal: 11604,
        otherExpensesTotal: 0,
        netOperatingProfitLossBeforeInterestAndTaxTotal: 1662,
        interestExpenseTotal: 0,
        incomeTaxTotal: 0,
        profitTotal: 1662,
        allocationAccountList: [
          {
            accountId: 101,
            total: 28224,
          },
          {
            accountId: 88,
            total: 42336,
          },
          {
            accountId: 108,
            total: 846,
          },
          {
            accountId: 201,
            total: 0,
          },
          {
            accountId: 160,
            total: 4504,
          },
          {
            accountId: 148,
            total: 7100,
          },
        ],
      },
      {
        allocationItemGroup: {
          name: "ร้านสุขุมวิท",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 479,
            },
          ],
        },
        revenueTotal: 102000,
        costOfSalesAndServicesTotal: 61200,
        grossProfitLossTotal: 40800,
        sellingExpensesTotal: 1020,
        administrativeExpenseTotal: 38623,
        otherExpensesTotal: 0,
        netOperatingProfitLossBeforeInterestAndTaxTotal: 1157,
        interestExpenseTotal: 0,
        incomeTaxTotal: 0,
        profitTotal: 1157,
        allocationAccountList: [
          {
            accountId: 157,
            total: 24000,
          },
          {
            accountId: 101,
            total: 61200,
          },
          {
            accountId: 88,
            total: 102000,
          },
          {
            accountId: 173,
            total: 2119,
          },
          {
            accountId: 108,
            total: 1020,
          },
          {
            accountId: 201,
            total: 0,
          },
          {
            accountId: 160,
            total: 4504,
          },
          {
            accountId: 148,
            total: 8000,
          },
        ],
      },
      {
        allocationItemGroup: {
          name: "ร้านสีลม",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 488,
            },
          ],
        },
        revenueTotal: 111725,
        costOfSalesAndServicesTotal: 89925,
        grossProfitLossTotal: 21800,
        sellingExpensesTotal: 1115,
        administrativeExpenseTotal: 20364,
        otherExpensesTotal: 0,
        netOperatingProfitLossBeforeInterestAndTaxTotal: 321,
        interestExpenseTotal: 0,
        incomeTaxTotal: 0,
        profitTotal: 321,
        allocationAccountList: [
          {
            accountId: 101,
            total: 89925,
          },
          {
            accountId: 88,
            total: 111725,
          },
          {
            accountId: 108,
            total: 1115,
          },
          {
            accountId: 201,
            total: 0,
          },
          {
            accountId: 160,
            total: 2864,
          },
          {
            accountId: 148,
            total: 14000,
          },
          {
            accountId: 173,
            total: 3500,
          },
        ],
      },
      {
        allocationItemGroup: {
          name: "ร้านบางบัวทอง",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 671,
            },
          ],
        },
        revenueTotal: 209450,
        costOfSalesAndServicesTotal: 142000,
        grossProfitLossTotal: 67450,
        sellingExpensesTotal: 2094,
        administrativeExpenseTotal: 38000,
        otherExpensesTotal: 8500,
        netOperatingProfitLossBeforeInterestAndTaxTotal: 18856,
        interestExpenseTotal: 0,
        incomeTaxTotal: 0,
        profitTotal: 18856,
        allocationAccountList: [
          {
            accountId: 101,
            total: 142000,
          },
          {
            accountId: 88,
            total: 209450,
          },
          {
            accountId: 108,
            total: 2094,
          },
          {
            accountId: 201,
            total: 8500,
          },
          {
            accountId: 160,
            total: 14000,
          },
          {
            accountId: 148,
            total: 24000,
          },
        ],
      },
    ],
    revenue: {
      total: 465511,
      changeVaue: 1000,
      changeFormType: 3,
      productTop1Id: 31739,
      productTop2Id: 31721,
      productTop3Id: 31719,
      productTop1Total: 209450,
      productTop2Total: 111725,
      productTop3Total: 102000,
      productOtherTotal: 42336,
      productTop1ChangeValue: 1000,
      productTop2ChangeValue: 1000,
      productTop3ChangeValue: 1000,
      contactTop1Total: 465511,
      contactTop2Total: 0,
      contactTop3Total: 0,
      contactTop1Id: 58278,
      contactTop2Id: 0,
      contactTop3Id: 0,
      contactOtherTotal: 0,
      contactTop1ChangeValue: 1000,
      contactTop2ChangeValue: 0,
      contactTop3ChangeValue: 0,
      accountTop1Id: 88,
      accountTop2Id: 0,
      accountTop3Id: 0,
      accountTop1Total: 465511,
      accountTop2Total: 0,
      accountTop3Total: 0,
      accountOtherTotal: 0,
      accountTop1ChangeValue: 1000,
      accountTop2ChangeValue: 0,
      accountTop3ChangeValue: 0,
    },
    expense: {
      total: 443515,
      changeVaue: 1000,
      changeFormType: 3,
      productTop1Id: 31739,
      productTop2Id: 31721,
      productTop3Id: 31719,
      productTop1Total: 142000,
      productTop2Total: 89925,
      productTop3Total: 61200,
      productOtherTotal: 150390,
      productTop1ChangeValue: 1000,
      productTop2ChangeValue: 1000,
      productTop3ChangeValue: 1000,
      contactTop1Total: 321349,
      contactTop2Total: 78972,
      contactTop3Total: 29619,
      contactTop1Id: 58278,
      contactTop2Id: 58279,
      contactTop3Id: 58280,
      contactOtherTotal: 13575,
      contactTop1ChangeValue: 1000,
      contactTop2ChangeValue: 1000,
      contactTop3ChangeValue: 1000,
      accountTop1Id: 101,
      accountTop2Id: 148,
      accountTop3Id: 160,
      accountTop1Total: 321349,
      accountTop2Total: 53100,
      accountTop3Total: 25872,
      accountOtherTotal: 43194,
      accountTop1ChangeValue: 1000,
      accountTop2ChangeValue: 1000,
      accountTop3ChangeValue: 1000,
      accountExpenseTypeTop1Id: 1,
      accountExpenseTypeTop2Id: 3,
      accountExpenseTypeTop3Id: 4,
      accountExpenseTypeTop1Total: 321349,
      accountExpenseTypeTop2Total: 108591,
      accountExpenseTypeTop3Total: 8500,
      accountExpenseTypeOtherTotal: 5075,
      accountExpenseTypeTop1ChangeValue: 1000,
      accountExpenseTypeTop2ChangeValue: 1000,
      accountExpenseTypeTop3ChangeValue: 1000,
    },
  };
  const thisYear = {
    customDashBoardId: 58,
    allocationId: 217,
    customDashboardGroup: {
      id: "60c6d7206aaaef5e9c9afb06",
      merchantId: 2788,
      createdDateTime: "2021-06-14T04:12:16.477Z",
      createdUserId: 2867,
      customDashboardId: 58,
      allocationId: 217,
      allocationItemGroupList: [
        {
          name: "ร้านรัชดาภิเษก",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 478,
            },
          ],
        },
        {
          name: "ร้านสุขุมวิท",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 479,
            },
          ],
        },
        {
          name: "ร้านสีลม",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 488,
            },
          ],
        },
        {
          name: "ร้านบางบัวทอง",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 671,
            },
          ],
        },
      ],
    },
    dashboardSelectOptionType: 3,
    fromDate: "2021-01-01T00:00:00",
    toDate: "2021-12-31T00:00:00",
    profitLossList: [
      {
        allocationItemGroup: {
          name: "ร้านรัชดาภิเษก",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 478,
            },
          ],
        },
        revenueTotal: 560782,
        costOfSalesAndServicesTotal: 371520,
        grossProfitLossTotal: 189262,
        sellingExpensesTotal: 11212,
        administrativeExpenseTotal: 142213,
        otherExpensesTotal: 1688.5,
        netOperatingProfitLossBeforeInterestAndTaxTotal: 34148.5,
        interestExpenseTotal: 0,
        incomeTaxTotal: 0,
        profitTotal: 34148.5,
        allocationAccountList: [
          {
            accountId: 101,
            total: 371520,
          },
          {
            accountId: 88,
            total: 560782,
          },
          {
            accountId: 108,
            total: 11212,
          },
          {
            accountId: 201,
            total: 1688.5,
          },
          {
            accountId: 160,
            total: 57913,
          },
          {
            accountId: 148,
            total: 84300,
          },
        ],
      },
      {
        allocationItemGroup: {
          name: "ร้านสุขุมวิท",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 479,
            },
          ],
        },
        revenueTotal: 1455700,
        costOfSalesAndServicesTotal: 873420,
        grossProfitLossTotal: 582280,
        sellingExpensesTotal: 14557,
        administrativeExpenseTotal: 501336,
        otherExpensesTotal: 7276,
        netOperatingProfitLossBeforeInterestAndTaxTotal: 59111,
        interestExpenseTotal: 0,
        incomeTaxTotal: 0,
        profitTotal: 59111,
        allocationAccountList: [
          {
            accountId: 101,
            total: 873420,
          },
          {
            accountId: 88,
            total: 1455700,
          },
          {
            accountId: 157,
            total: 43600,
          },
          {
            accountId: 173,
            total: 303390,
          },
          {
            accountId: 108,
            total: 14557,
          },
          {
            accountId: 201,
            total: 7276,
          },
          {
            accountId: 160,
            total: 58346,
          },
          {
            accountId: 148,
            total: 96000,
          },
        ],
      },
      {
        allocationItemGroup: {
          name: "ร้านสีลม",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 488,
            },
          ],
        },
        revenueTotal: 1140210,
        costOfSalesAndServicesTotal: 917730,
        grossProfitLossTotal: 222480,
        sellingExpensesTotal: 11376,
        administrativeExpenseTotal: 242860,
        otherExpensesTotal: 4307.5,
        netOperatingProfitLossBeforeInterestAndTaxTotal: -36063.5,
        interestExpenseTotal: 0,
        incomeTaxTotal: 0,
        profitTotal: -36063.5,
        allocationAccountList: [
          {
            accountId: 101,
            total: 917730,
          },
          {
            accountId: 88,
            total: 1140210,
          },
          {
            accountId: 108,
            total: 11376,
          },
          {
            accountId: 201,
            total: 4307.5,
          },
          {
            accountId: 160,
            total: 32860,
          },
          {
            accountId: 148,
            total: 168000,
          },
          {
            accountId: 173,
            total: 42000,
          },
        ],
      },
      {
        allocationItemGroup: {
          name: "ร้านบางบัวทอง",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 671,
            },
          ],
        },
        revenueTotal: 2802395,
        costOfSalesAndServicesTotal: 1990000,
        grossProfitLossTotal: 812395,
        sellingExpensesTotal: 29811,
        administrativeExpenseTotal: 456000,
        otherExpensesTotal: 109400,
        netOperatingProfitLossBeforeInterestAndTaxTotal: 217184,
        interestExpenseTotal: 0,
        incomeTaxTotal: 0,
        profitTotal: 217184,
        allocationAccountList: [
          {
            accountId: 101,
            total: 1990000,
          },
          {
            accountId: 88,
            total: 2802395,
          },
          {
            accountId: 108,
            total: 29811,
          },
          {
            accountId: 201,
            total: 109400,
          },
          {
            accountId: 160,
            total: 168000,
          },
          {
            accountId: 148,
            total: 288000,
          },
        ],
      },
    ],
    revenue: {
      total: 5959087,
      changeVaue: -1,
      changeFormType: 5,
      productTop1Id: 31739,
      productTop2Id: 31719,
      productTop3Id: 31721,
      productTop1Total: 2802395,
      productTop2Total: 1455700,
      productTop3Total: 1140210,
      productOtherTotal: 560782,
      productTop1ChangeValue: -5.05,
      productTop2ChangeValue: 7.84,
      productTop3ChangeValue: -1.44,
      contactTop1Total: 5959087,
      contactTop2Total: 0,
      contactTop3Total: 0,
      contactTop1Id: 58278,
      contactTop2Id: 0,
      contactTop3Id: 0,
      contactOtherTotal: 0,
      contactTop1ChangeValue: -1,
      contactTop2ChangeValue: 0,
      contactTop3ChangeValue: 0,
      accountTop1Id: 88,
      accountTop2Id: 0,
      accountTop3Id: 0,
      accountTop1Total: 5959087,
      accountTop2Total: 0,
      accountTop3Total: 0,
      accountOtherTotal: 0,
      accountTop1ChangeValue: -1,
      accountTop2ChangeValue: 0,
      accountTop3ChangeValue: 0,
    },
    expense: {
      total: 5684707,
      changeVaue: -1.02,
      changeFormType: 5,
      productTop1Id: 31739,
      productTop2Id: 31721,
      productTop3Id: 31719,
      productTop1Total: 1990000,
      productTop2Total: 917730,
      productTop3Total: 873420,
      productOtherTotal: 1903557,
      productTop1ChangeValue: -8.97,
      productTop2ChangeValue: -1.44,
      productTop3ChangeValue: 7.84,
      contactTop1Total: 4152670,
      contactTop2Total: 953419,
      contactTop3Total: 388990,
      contactTop1Id: 58278,
      contactTop2Id: 58279,
      contactTop3Id: 58280,
      contactOtherTotal: 189628,
      contactTop1ChangeValue: -3.46,
      contactTop2ChangeValue: 5.38,
      contactTop3ChangeValue: 6.46,
      accountTop1Id: 101,
      accountTop2Id: 148,
      accountTop3Id: 173,
      accountTop1Total: 4152670,
      accountTop2Total: 636300,
      accountTop3Total: 345390,
      accountOtherTotal: 550347,
      accountTop1ChangeValue: -3.46,
      accountTop2ChangeValue: 4.06,
      accountTop3ChangeValue: -8.48,
      accountExpenseTypeTop1Id: 1,
      accountExpenseTypeTop2Id: 3,
      accountExpenseTypeTop3Id: 4,
      accountExpenseTypeTop1Total: 4152670,
      accountExpenseTypeTop2Total: 1342409,
      accountExpenseTypeTop3Total: 122672,
      accountExpenseTypeOtherTotal: 66956,
      accountExpenseTypeTop1ChangeValue: -3.46,
      accountExpenseTypeTop2ChangeValue: 5.69,
      accountExpenseTypeTop3ChangeValue: 16.15,
    },
  };
  const lastYear = {
    customDashBoardId: 58,
    allocationId: 217,
    customDashboardGroup: {
      id: "60c6d7206aaaef5e9c9afb06",
      merchantId: 2788,
      createdDateTime: "2021-06-14T04:12:16.477Z",
      createdUserId: 2867,
      customDashboardId: 58,
      allocationId: 217,
      allocationItemGroupList: [
        {
          name: "ร้านรัชดาภิเษก",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 478,
            },
          ],
        },
        {
          name: "ร้านสุขุมวิท",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 479,
            },
          ],
        },
        {
          name: "ร้านสีลม",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 488,
            },
          ],
        },
        {
          name: "ร้านบางบัวทอง",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 671,
            },
          ],
        },
      ],
    },
    dashboardSelectOptionType: 4,
    fromDate: "2020-01-01T00:00:00",
    toDate: "2020-12-31T00:00:00",
    profitLossList: [
      {
        allocationItemGroup: {
          name: "ร้านรัชดาภิเษก",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 478,
            },
          ],
        },
        revenueTotal: 561384,
        costOfSalesAndServicesTotal: 374256,
        grossProfitLossTotal: 187128,
        sellingExpensesTotal: 9833,
        administrativeExpenseTotal: 138659,
        otherExpensesTotal: 4446,
        netOperatingProfitLossBeforeInterestAndTaxTotal: 34190,
        interestExpenseTotal: 0,
        incomeTaxTotal: 0,
        profitTotal: 34190,
        allocationAccountList: [
          {
            accountId: 160,
            total: 58559,
          },
          {
            accountId: 148,
            total: 80100,
          },
          {
            accountId: 108,
            total: 9833,
          },
          {
            accountId: 201,
            total: 4446,
          },
          {
            accountId: 101,
            total: 374256,
          },
          {
            accountId: 88,
            total: 561384,
          },
        ],
      },
      {
        allocationItemGroup: {
          name: "ร้านสุขุมวิท",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 479,
            },
          ],
        },
        revenueTotal: 1349900,
        costOfSalesAndServicesTotal: 809940,
        grossProfitLossTotal: 539960,
        sellingExpensesTotal: 14890,
        administrativeExpenseTotal: 468700,
        otherExpensesTotal: 4346,
        netOperatingProfitLossBeforeInterestAndTaxTotal: 52024,
        interestExpenseTotal: 0,
        incomeTaxTotal: 0,
        profitTotal: 52024,
        allocationAccountList: [
          {
            accountId: 160,
            total: 58310,
          },
          {
            accountId: 148,
            total: 85000,
          },
          {
            accountId: 108,
            total: 14890,
          },
          {
            accountId: 201,
            total: 4346,
          },
          {
            accountId: 173,
            total: 325390,
          },
          {
            accountId: 101,
            total: 809940,
          },
          {
            accountId: 88,
            total: 1349900,
          },
        ],
      },
      {
        allocationItemGroup: {
          name: "ร้านสีลม",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 488,
            },
          ],
        },
        revenueTotal: 1156815,
        costOfSalesAndServicesTotal: 931095,
        grossProfitLossTotal: 225720,
        sellingExpensesTotal: 11542,
        administrativeExpenseTotal: 230793,
        otherExpensesTotal: 2781,
        netOperatingProfitLossBeforeInterestAndTaxTotal: -19396,
        interestExpenseTotal: 0,
        incomeTaxTotal: 0,
        profitTotal: -19396,
        allocationAccountList: [
          {
            accountId: 160,
            total: 32393,
          },
          {
            accountId: 148,
            total: 158400,
          },
          {
            accountId: 108,
            total: 11542,
          },
          {
            accountId: 201,
            total: 2781,
          },
          {
            accountId: 173,
            total: 40000,
          },
          {
            accountId: 101,
            total: 931095,
          },
          {
            accountId: 88,
            total: 1156815,
          },
        ],
      },
      {
        allocationItemGroup: {
          name: "ร้านบางบัวทอง",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 671,
            },
          ],
        },
        revenueTotal: 2951370,
        costOfSalesAndServicesTotal: 2186200,
        grossProfitLossTotal: 765170,
        sellingExpensesTotal: 29509.1,
        administrativeExpenseTotal: 432000,
        otherExpensesTotal: 94040,
        netOperatingProfitLossBeforeInterestAndTaxTotal: 209620.9,
        interestExpenseTotal: 0,
        incomeTaxTotal: 0,
        profitTotal: 209620.9,
        allocationAccountList: [
          {
            accountId: 160,
            total: 132000,
          },
          {
            accountId: 148,
            total: 288000,
          },
          {
            accountId: 108,
            total: 29509.1,
          },
          {
            accountId: 201,
            total: 94040,
          },
          {
            accountId: 101,
            total: 2186200,
          },
          {
            accountId: 88,
            total: 2951370,
          },
          {
            accountId: 173,
            total: 12000,
          },
        ],
      },
    ],
    revenue: {
      total: 6019469,
      changeVaue: 1000,
      changeFormType: 5,
      productTop1Id: 31739,
      productTop2Id: 31719,
      productTop3Id: 31721,
      productTop1Total: 2951370,
      productTop2Total: 1349900,
      productTop3Total: 1156815,
      productOtherTotal: 561384,
      productTop1ChangeValue: 1000,
      productTop2ChangeValue: 1000,
      productTop3ChangeValue: 1000,
      contactTop1Total: 6019469,
      contactTop2Total: 0,
      contactTop3Total: 0,
      contactTop1Id: 58278,
      contactTop2Id: 0,
      contactTop3Id: 0,
      contactOtherTotal: 0,
      contactTop1ChangeValue: 1000,
      contactTop2ChangeValue: 0,
      contactTop3ChangeValue: 0,
      accountTop1Id: 88,
      accountTop2Id: 0,
      accountTop3Id: 0,
      accountTop1Total: 6019469,
      accountTop2Total: 0,
      accountTop3Total: 0,
      accountOtherTotal: 0,
      accountTop1ChangeValue: 1000,
      accountTop2ChangeValue: 0,
      accountTop3ChangeValue: 0,
    },
    expense: {
      total: 5743030.1,
      changeVaue: 1000,
      changeFormType: 5,
      productTop1Id: 31739,
      productTop2Id: 31721,
      productTop3Id: 31719,
      productTop1Total: 2186200,
      productTop2Total: 931095,
      productTop3Total: 809940,
      productOtherTotal: 1815795.1,
      productTop1ChangeValue: 1000,
      productTop2ChangeValue: 1000,
      productTop3ChangeValue: 1000,
      contactTop1Total: 4301491,
      contactTop2Total: 904762,
      contactTop3Total: 365390,
      contactTop1Id: 58278,
      contactTop2Id: 58279,
      contactTop3Id: 58280,
      contactOtherTotal: 171387.1,
      contactTop1ChangeValue: 1000,
      contactTop2ChangeValue: 1000,
      contactTop3ChangeValue: 1000,
      accountTop1Id: 101,
      accountTop2Id: 148,
      accountTop3Id: 173,
      accountTop1Total: 4301491,
      accountTop2Total: 611500,
      accountTop3Total: 377390,
      accountOtherTotal: 452649.1,
      accountTop1ChangeValue: 1000,
      accountTop2ChangeValue: 1000,
      accountTop3ChangeValue: 1000,
      accountExpenseTypeTop1Id: 1,
      accountExpenseTypeTop2Id: 3,
      accountExpenseTypeTop3Id: 4,
      accountExpenseTypeTop1Total: 4301491,
      accountExpenseTypeTop2Total: 1270152,
      accountExpenseTypeTop3Total: 105613,
      accountExpenseTypeOtherTotal: 65774.1,
      accountExpenseTypeTop1ChangeValue: 1000,
      accountExpenseTypeTop2ChangeValue: 1000,
      accountExpenseTypeTop3ChangeValue: 1000,
    },
  };

  switch (dashboardSelectOptionType) {
    case DashboardSelectOptionType.ThisMonth:
      return thisMonth;
      break;
    case DashboardSelectOptionType.LastMonth:
      return lastMonth;
      break;
    case DashboardSelectOptionType.ThisYear:
      return thisYear;
      break;
    case DashboardSelectOptionType.LastYear:
      return lastYear;
      break;
  }
}

export function GetCustomDashboardDetailMockup(dashboardSelectOptionType: DashboardSelectOptionType) {
  const thisMonth = {
    customDashBoardId: 64,
    allocationId: 217,
    customDashboardGroup: {
      id: "60c1c8e30e70293c942c67d2",
      merchantId: 2788,
      createdDateTime: "2021-06-10T08:10:11.885Z",
      createdUserId: 2867,
      customDashboardId: 64,
      allocationId: 217,
      allocationItemGroupList: [
        {
          name: "ร้านรัชดาภิเษก",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 478,
            },
          ],
        },
      ],
    },
    dashboardSelectOptionType: 1,
    fromDate: "2021-12-01T00:00:00",
    toDate: "2021-12-31T00:00:00",
    revenueSummaryTotal: 47998,
    expenseSummaryTotal: 42224,
    profitSummaryTotal: 5774,
    summaryDetail: {
      revenueSummaryTotal: 47998,
      expenseSummaryTotal: 42224,
      profitSummaryTotal: 5774,
      changeFormType: 3,
      revenueSummaryChangeValue: 1288.83,
      expenseSummaryChangeValue: 1732.64,
      profitSummaryChangeValue: 401.22,
      allocationSummaryItemDetailList: [
        {
          date: "2021-12-01T00:00:00",
          revenueTotal: 699,
          expenseTotal: 432,
          profitTotal: 267,
          revenueChangeValue: -79.77,
          expenseChangeValue: -81.25,
          profitChangeValue: -76.82,
          changeFormType: 1,
        },
        {
          date: "2021-12-02T00:00:00",
          revenueTotal: 0,
          expenseTotal: 0,
          profitTotal: 0,
          revenueChangeValue: -100,
          expenseChangeValue: -100,
          profitChangeValue: -100,
          changeFormType: 1,
        },
        {
          date: "2021-12-03T00:00:00",
          revenueTotal: 2796,
          expenseTotal: 1728,
          profitTotal: 1068,
          revenueChangeValue: 1000,
          expenseChangeValue: 1000,
          profitChangeValue: 1000,
          changeFormType: 1,
        },
        {
          date: "2021-12-04T00:00:00",
          revenueTotal: 1398,
          expenseTotal: 864,
          profitTotal: 534,
          revenueChangeValue: -50,
          expenseChangeValue: -50,
          profitChangeValue: -50,
          changeFormType: 1,
        },
        {
          date: "2021-12-05T00:00:00",
          revenueTotal: 1398,
          expenseTotal: 864,
          profitTotal: 534,
          revenueChangeValue: 0,
          expenseChangeValue: 0,
          profitChangeValue: 0,
          changeFormType: 1,
        },
        {
          date: "2021-12-06T00:00:00",
          revenueTotal: 0,
          expenseTotal: 0,
          profitTotal: 0,
          revenueChangeValue: -100,
          expenseChangeValue: -100,
          profitChangeValue: -100,
          changeFormType: 1,
        },
        {
          date: "2021-12-07T00:00:00",
          revenueTotal: 2796,
          expenseTotal: 1728,
          profitTotal: 1068,
          revenueChangeValue: 1000,
          expenseChangeValue: 1000,
          profitChangeValue: 1000,
          changeFormType: 1,
        },
        {
          date: "2021-12-08T00:00:00",
          revenueTotal: 0,
          expenseTotal: 0,
          profitTotal: 0,
          revenueChangeValue: -100,
          expenseChangeValue: -100,
          profitChangeValue: -100,
          changeFormType: 1,
        },
        {
          date: "2021-12-09T00:00:00",
          revenueTotal: 2796,
          expenseTotal: 1728,
          profitTotal: 1068,
          revenueChangeValue: 1000,
          expenseChangeValue: 1000,
          profitChangeValue: 1000,
          changeFormType: 1,
        },
        {
          date: "2021-12-10T00:00:00",
          revenueTotal: 2097,
          expenseTotal: 1296,
          profitTotal: 801,
          revenueChangeValue: -25,
          expenseChangeValue: -25,
          profitChangeValue: -25,
          changeFormType: 1,
        },
        {
          date: "2021-12-11T00:00:00",
          revenueTotal: 699,
          expenseTotal: 432,
          profitTotal: 267,
          revenueChangeValue: -66.67,
          expenseChangeValue: -66.67,
          profitChangeValue: -66.67,
          changeFormType: 1,
        },
        {
          date: "2021-12-12T00:00:00",
          revenueTotal: 699,
          expenseTotal: 432,
          profitTotal: 267,
          revenueChangeValue: 0,
          expenseChangeValue: 0,
          profitChangeValue: 0,
          changeFormType: 1,
        },
        {
          date: "2021-12-13T00:00:00",
          revenueTotal: 0,
          expenseTotal: 0,
          profitTotal: 0,
          revenueChangeValue: -100,
          expenseChangeValue: -100,
          profitChangeValue: -100,
          changeFormType: 1,
        },
        {
          date: "2021-12-14T00:00:00",
          revenueTotal: 1398,
          expenseTotal: 864,
          profitTotal: 534,
          revenueChangeValue: 1000,
          expenseChangeValue: 1000,
          profitChangeValue: 1000,
          changeFormType: 1,
        },
        {
          date: "2021-12-15T00:00:00",
          revenueTotal: 2097,
          expenseTotal: 1296,
          profitTotal: 801,
          revenueChangeValue: 50,
          expenseChangeValue: 50,
          profitChangeValue: 50,
          changeFormType: 1,
        },
        {
          date: "2021-12-16T00:00:00",
          revenueTotal: 2097,
          expenseTotal: 12896,
          profitTotal: -10799,
          revenueChangeValue: 0,
          expenseChangeValue: 895.06,
          profitChangeValue: -1448.19,
          changeFormType: 1,
        },
        {
          date: "2021-12-17T00:00:00",
          revenueTotal: 1398,
          expenseTotal: 864,
          profitTotal: 534,
          revenueChangeValue: -33.33,
          expenseChangeValue: -93.3,
          profitChangeValue: 104.94,
          changeFormType: 1,
        },
        {
          date: "2021-12-18T00:00:00",
          revenueTotal: 0,
          expenseTotal: 0,
          profitTotal: 0,
          revenueChangeValue: -100,
          expenseChangeValue: -100,
          profitChangeValue: -100,
          changeFormType: 1,
        },
        {
          date: "2021-12-19T00:00:00",
          revenueTotal: 1398,
          expenseTotal: 864,
          profitTotal: 534,
          revenueChangeValue: 1000,
          expenseChangeValue: 1000,
          profitChangeValue: 1000,
          changeFormType: 1,
        },
        {
          date: "2021-12-20T00:00:00",
          revenueTotal: 0,
          expenseTotal: 0,
          profitTotal: 0,
          revenueChangeValue: -100,
          expenseChangeValue: -100,
          profitChangeValue: -100,
          changeFormType: 1,
        },
        {
          date: "2021-12-21T00:00:00",
          revenueTotal: 3495,
          expenseTotal: 2160,
          profitTotal: 1335,
          revenueChangeValue: 1000,
          expenseChangeValue: 1000,
          profitChangeValue: 1000,
          changeFormType: 1,
        },
        {
          date: "2021-12-22T00:00:00",
          revenueTotal: 2213.5,
          expenseTotal: 1368,
          profitTotal: 845.5,
          revenueChangeValue: -36.67,
          expenseChangeValue: -36.67,
          profitChangeValue: -36.67,
          changeFormType: 1,
        },
        {
          date: "2021-12-23T00:00:00",
          revenueTotal: 2097,
          expenseTotal: 1296,
          profitTotal: 801,
          revenueChangeValue: -5.26,
          expenseChangeValue: -5.26,
          profitChangeValue: -5.26,
          changeFormType: 1,
        },
        {
          date: "2021-12-24T00:00:00",
          revenueTotal: 2796,
          expenseTotal: 1728,
          profitTotal: 1068,
          revenueChangeValue: 33.33,
          expenseChangeValue: 33.33,
          profitChangeValue: 33.33,
          changeFormType: 1,
        },
        {
          date: "2021-12-25T00:00:00",
          revenueTotal: 2097,
          expenseTotal: 2256,
          profitTotal: -159,
          revenueChangeValue: -25,
          expenseChangeValue: 30.56,
          profitChangeValue: -114.89,
          changeFormType: 1,
        },
        {
          date: "2021-12-26T00:00:00",
          revenueTotal: 1747.5,
          expenseTotal: 1080,
          profitTotal: 667.5,
          revenueChangeValue: -16.67,
          expenseChangeValue: -52.13,
          profitChangeValue: 519.81,
          changeFormType: 1,
        },
        {
          date: "2021-12-27T00:00:00",
          revenueTotal: 0,
          expenseTotal: 0,
          profitTotal: 0,
          revenueChangeValue: -100,
          expenseChangeValue: -100,
          profitChangeValue: -100,
          changeFormType: 1,
        },
        {
          date: "2021-12-28T00:00:00",
          revenueTotal: 2097,
          expenseTotal: 1296,
          profitTotal: 801,
          revenueChangeValue: 1000,
          expenseChangeValue: 1000,
          profitChangeValue: 1000,
          changeFormType: 1,
        },
        {
          date: "2021-12-29T00:00:00",
          revenueTotal: 1398,
          expenseTotal: 864,
          profitTotal: 534,
          revenueChangeValue: -33.33,
          expenseChangeValue: -33.33,
          profitChangeValue: -33.33,
          changeFormType: 1,
        },
        {
          date: "2021-12-30T00:00:00",
          revenueTotal: 3495,
          expenseTotal: 2160,
          profitTotal: 1335,
          revenueChangeValue: 150,
          expenseChangeValue: 150,
          profitChangeValue: 150,
          changeFormType: 1,
        },
        {
          date: "2021-12-31T00:00:00",
          revenueTotal: 2796,
          expenseTotal: 1728,
          profitTotal: 1068,
          revenueChangeValue: -20,
          expenseChangeValue: -20,
          profitChangeValue: -20,
          changeFormType: 1,
        },
      ],
    },
    profitLossDetail: {
      revenueTotal: 47998,
      costOfSalesAndServicesTotal: 29664,
      grossProfitLossTotal: 18334,
      sellingExpensesTotal: 960,
      administrativeExpenseTotal: 11600,
      otherExpensesTotal: 0,
      netOperatingProfitLossBeforeInterestAndTaxTotal: 5774,
      interestExpenseTotal: 0,
      incomeTaxTotal: 0,
      profitTotal: 5774,
      allocationAccountList: [
        {
          accountId: 101,
          total: 29664,
        },
        {
          accountId: 88,
          total: 47998,
        },
        {
          accountId: 108,
          total: 960,
        },
        {
          accountId: 201,
          total: 0,
        },
        {
          accountId: 160,
          total: 4500,
        },
        {
          accountId: 148,
          total: 7100,
        },
      ],
    },
    revenue: {
      total: 47998,
      changeVaue: 1288.83,
      changeFormType: 3,
      productTop1Id: 31720,
      productTop2Id: 0,
      productTop3Id: 0,
      productTop1Total: 47998,
      productTop2Total: 0,
      productTop3Total: 0,
      productOtherTotal: 0,
      productTop1ChangeValue: 1288.83,
      productTop2ChangeValue: 0,
      productTop3ChangeValue: 0,
      contactTop1Total: 47998,
      contactTop2Total: 0,
      contactTop3Total: 0,
      contactTop1Id: 58278,
      contactTop2Id: 0,
      contactTop3Id: 0,
      contactOtherTotal: 0,
      contactTop1ChangeValue: 1288.83,
      contactTop2ChangeValue: 0,
      contactTop3ChangeValue: 0,
      accountTop1Id: 88,
      accountTop2Id: 0,
      accountTop3Id: 0,
      accountTop1Total: 47998,
      accountTop2Total: 0,
      accountTop3Total: 0,
      accountOtherTotal: 0,
      accountTop1ChangeValue: 1288.83,
      accountTop2ChangeValue: 0,
      accountTop3ChangeValue: 0,
    },
    expense: {
      total: 42224,
      changeVaue: 1732.64,
      changeFormType: 3,
      productTop1Id: 31720,
      productTop2Id: 0,
      productTop3Id: 0,
      productTop1Total: 29664,
      productTop2Total: 0,
      productTop3Total: 0,
      productOtherTotal: 12560,
      productTop1ChangeValue: 1187.5,
      productTop2ChangeValue: 0,
      productTop3ChangeValue: 0,
      contactTop1Total: 29664,
      contactTop2Total: 11600,
      contactTop3Total: 960,
      contactTop1Id: 58278,
      contactTop2Id: 58279,
      contactTop3Id: 58282,
      contactOtherTotal: 0,
      contactTop1ChangeValue: 1187.5,
      contactTop2ChangeValue: 1000,
      contactTop3ChangeValue: 1000,
      accountTop1Id: 101,
      accountTop2Id: 148,
      accountTop3Id: 160,
      accountTop1Total: 29664,
      accountTop2Total: 7100,
      accountTop3Total: 4500,
      accountOtherTotal: 960,
      accountTop1ChangeValue: 1187.5,
      accountTop2ChangeValue: 1000,
      accountTop3ChangeValue: 1000,
      accountExpenseTypeTop1Id: 1,
      accountExpenseTypeTop2Id: 3,
      accountExpenseTypeTop3Id: 2,
      accountExpenseTypeTop1Total: 29664,
      accountExpenseTypeTop2Total: 11600,
      accountExpenseTypeTop3Total: 960,
      accountExpenseTypeOtherTotal: 0,
      accountExpenseTypeTop1ChangeValue: 1187.5,
      accountExpenseTypeTop2ChangeValue: 1000,
      accountExpenseTypeTop3ChangeValue: 1000,
    },
  };
  const lastMonth = {
    customDashBoardId: 64,
    allocationId: 217,
    customDashboardGroup: {
      id: "60c1c8e30e70293c942c67d2",
      merchantId: 2788,
      createdDateTime: "2021-06-10T08:10:11.885Z",
      createdUserId: 2867,
      customDashboardId: 64,
      allocationId: 217,
      allocationItemGroupList: [
        {
          name: "ร้านรัชดาภิเษก",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 478,
            },
          ],
        },
      ],
    },
    dashboardSelectOptionType: 6,
    fromDate: "2021-11-01T00:00:00",
    toDate: "2021-11-30T00:00:00",
    revenueSummaryTotal: 42336,
    expenseSummaryTotal: 40674,
    profitSummaryTotal: 1662,
    summaryDetail: {
      revenueSummaryTotal: 42336,
      expenseSummaryTotal: 40674,
      profitSummaryTotal: 1662,
      changeFormType: 3,
      revenueSummaryChangeValue: 1000,
      expenseSummaryChangeValue: 1000,
      profitSummaryChangeValue: 1000,
      allocationSummaryItemDetailList: [
        {
          date: "2021-11-01T00:00:00",
          revenueTotal: 648,
          expenseTotal: 432,
          profitTotal: 216,
          revenueChangeValue: 1000,
          expenseChangeValue: 1000,
          profitChangeValue: 1000,
          changeFormType: 1,
        },
        {
          date: "2021-11-02T00:00:00",
          revenueTotal: 0,
          expenseTotal: 0,
          profitTotal: 0,
          revenueChangeValue: -100,
          expenseChangeValue: -100,
          profitChangeValue: -100,
          changeFormType: 1,
        },
        {
          date: "2021-11-03T00:00:00",
          revenueTotal: 2808,
          expenseTotal: 1872,
          profitTotal: 936,
          revenueChangeValue: 1000,
          expenseChangeValue: 1000,
          profitChangeValue: 1000,
          changeFormType: 1,
        },
        {
          date: "2021-11-04T00:00:00",
          revenueTotal: 1404,
          expenseTotal: 936,
          profitTotal: 468,
          revenueChangeValue: -50,
          expenseChangeValue: -50,
          profitChangeValue: -50,
          changeFormType: 1,
        },
        {
          date: "2021-11-05T00:00:00",
          revenueTotal: 1404,
          expenseTotal: 936,
          profitTotal: 468,
          revenueChangeValue: 0,
          expenseChangeValue: 0,
          profitChangeValue: 0,
          changeFormType: 1,
        },
        {
          date: "2021-11-06T00:00:00",
          revenueTotal: 0,
          expenseTotal: 0,
          profitTotal: 0,
          revenueChangeValue: -100,
          expenseChangeValue: -100,
          profitChangeValue: -100,
          changeFormType: 1,
        },
        {
          date: "2021-11-07T00:00:00",
          revenueTotal: 2808,
          expenseTotal: 1872,
          profitTotal: 936,
          revenueChangeValue: 1000,
          expenseChangeValue: 1000,
          profitChangeValue: 1000,
          changeFormType: 1,
        },
        {
          date: "2021-11-08T00:00:00",
          revenueTotal: 0,
          expenseTotal: 0,
          profitTotal: 0,
          revenueChangeValue: -100,
          expenseChangeValue: -100,
          profitChangeValue: -100,
          changeFormType: 1,
        },
        {
          date: "2021-11-09T00:00:00",
          revenueTotal: 1296,
          expenseTotal: 864,
          profitTotal: 432,
          revenueChangeValue: 1000,
          expenseChangeValue: 1000,
          profitChangeValue: 1000,
          changeFormType: 1,
        },
        {
          date: "2021-11-10T00:00:00",
          revenueTotal: 2160,
          expenseTotal: 1440,
          profitTotal: 720,
          revenueChangeValue: 66.67,
          expenseChangeValue: 66.67,
          profitChangeValue: 66.67,
          changeFormType: 1,
        },
        {
          date: "2021-11-11T00:00:00",
          revenueTotal: 648,
          expenseTotal: 432,
          profitTotal: 216,
          revenueChangeValue: -70,
          expenseChangeValue: -70,
          profitChangeValue: -70,
          changeFormType: 1,
        },
        {
          date: "2021-11-12T00:00:00",
          revenueTotal: 648,
          expenseTotal: 432,
          profitTotal: 216,
          revenueChangeValue: 0,
          expenseChangeValue: 0,
          profitChangeValue: 0,
          changeFormType: 1,
        },
        {
          date: "2021-11-13T00:00:00",
          revenueTotal: 0,
          expenseTotal: 0,
          profitTotal: 0,
          revenueChangeValue: -100,
          expenseChangeValue: -100,
          profitChangeValue: -100,
          changeFormType: 1,
        },
        {
          date: "2021-11-14T00:00:00",
          revenueTotal: 1404,
          expenseTotal: 936,
          profitTotal: 468,
          revenueChangeValue: 1000,
          expenseChangeValue: 1000,
          profitChangeValue: 1000,
          changeFormType: 1,
        },
        {
          date: "2021-11-15T00:00:00",
          revenueTotal: 864,
          expenseTotal: 576,
          profitTotal: 288,
          revenueChangeValue: -38.46,
          expenseChangeValue: -38.46,
          profitChangeValue: -38.46,
          changeFormType: 1,
        },
        {
          date: "2021-11-16T00:00:00",
          revenueTotal: 2160,
          expenseTotal: 13044,
          profitTotal: -10884,
          revenueChangeValue: 150,
          expenseChangeValue: 2164.58,
          profitChangeValue: -3879.17,
          changeFormType: 1,
        },
        {
          date: "2021-11-17T00:00:00",
          revenueTotal: 1296,
          expenseTotal: 864,
          profitTotal: 432,
          revenueChangeValue: -40,
          expenseChangeValue: -93.38,
          profitChangeValue: 103.97,
          changeFormType: 1,
        },
        {
          date: "2021-11-18T00:00:00",
          revenueTotal: 2808,
          expenseTotal: 1872,
          profitTotal: 936,
          revenueChangeValue: 116.67,
          expenseChangeValue: 116.67,
          profitChangeValue: 116.67,
          changeFormType: 1,
        },
        {
          date: "2021-11-19T00:00:00",
          revenueTotal: 1296,
          expenseTotal: 864,
          profitTotal: 432,
          revenueChangeValue: -53.85,
          expenseChangeValue: -53.85,
          profitChangeValue: -53.85,
          changeFormType: 1,
        },
        {
          date: "2021-11-20T00:00:00",
          revenueTotal: 0,
          expenseTotal: 0,
          profitTotal: 0,
          revenueChangeValue: -100,
          expenseChangeValue: -100,
          profitChangeValue: -100,
          changeFormType: 1,
        },
        {
          date: "2021-11-21T00:00:00",
          revenueTotal: 1296,
          expenseTotal: 864,
          profitTotal: 432,
          revenueChangeValue: 1000,
          expenseChangeValue: 1000,
          profitChangeValue: 1000,
          changeFormType: 1,
        },
        {
          date: "2021-11-22T00:00:00",
          revenueTotal: 2160,
          expenseTotal: 1440,
          profitTotal: 720,
          revenueChangeValue: 66.67,
          expenseChangeValue: 66.67,
          profitChangeValue: 66.67,
          changeFormType: 1,
        },
        {
          date: "2021-11-23T00:00:00",
          revenueTotal: 1512,
          expenseTotal: 1008,
          profitTotal: 504,
          revenueChangeValue: -30,
          expenseChangeValue: -30,
          profitChangeValue: -30,
          changeFormType: 1,
        },
        {
          date: "2021-11-24T00:00:00",
          revenueTotal: 2808,
          expenseTotal: 1872,
          profitTotal: 936,
          revenueChangeValue: 85.71,
          expenseChangeValue: 85.71,
          profitChangeValue: 85.71,
          changeFormType: 1,
        },
        {
          date: "2021-11-25T00:00:00",
          revenueTotal: 2160,
          expenseTotal: 2286,
          profitTotal: -126,
          revenueChangeValue: -23.08,
          expenseChangeValue: 22.12,
          profitChangeValue: -113.46,
          changeFormType: 1,
        },
        {
          date: "2021-11-26T00:00:00",
          revenueTotal: 1728,
          expenseTotal: 1152,
          profitTotal: 576,
          revenueChangeValue: -20,
          expenseChangeValue: -49.61,
          profitChangeValue: 557.14,
          changeFormType: 1,
        },
        {
          date: "2021-11-27T00:00:00",
          revenueTotal: 0,
          expenseTotal: 0,
          profitTotal: 0,
          revenueChangeValue: -100,
          expenseChangeValue: -100,
          profitChangeValue: -100,
          changeFormType: 1,
        },
        {
          date: "2021-11-28T00:00:00",
          revenueTotal: 2160,
          expenseTotal: 1440,
          profitTotal: 720,
          revenueChangeValue: 1000,
          expenseChangeValue: 1000,
          profitChangeValue: 1000,
          changeFormType: 1,
        },
        {
          date: "2021-11-29T00:00:00",
          revenueTotal: 1404,
          expenseTotal: 936,
          profitTotal: 468,
          revenueChangeValue: -35,
          expenseChangeValue: -35,
          profitChangeValue: -35,
          changeFormType: 1,
        },
        {
          date: "2021-11-30T00:00:00",
          revenueTotal: 3456,
          expenseTotal: 2304,
          profitTotal: 1152,
          revenueChangeValue: 146.15,
          expenseChangeValue: 146.15,
          profitChangeValue: 146.15,
          changeFormType: 1,
        },
      ],
    },
    profitLossDetail: {
      revenueTotal: 42336,
      costOfSalesAndServicesTotal: 28224,
      grossProfitLossTotal: 14112,
      sellingExpensesTotal: 846,
      administrativeExpenseTotal: 11604,
      otherExpensesTotal: 0,
      netOperatingProfitLossBeforeInterestAndTaxTotal: 1662,
      interestExpenseTotal: 0,
      incomeTaxTotal: 0,
      profitTotal: 1662,
      allocationAccountList: [
        {
          accountId: 101,
          total: 28224,
        },
        {
          accountId: 88,
          total: 42336,
        },
        {
          accountId: 108,
          total: 846,
        },
        {
          accountId: 201,
          total: 0,
        },
        {
          accountId: 160,
          total: 4504,
        },
        {
          accountId: 148,
          total: 7100,
        },
      ],
    },
    revenue: {
      total: 42336,
      changeVaue: 1000,
      changeFormType: 3,
      productTop1Id: 31720,
      productTop2Id: 0,
      productTop3Id: 0,
      productTop1Total: 42336,
      productTop2Total: 0,
      productTop3Total: 0,
      productOtherTotal: 0,
      productTop1ChangeValue: 1000,
      productTop2ChangeValue: 0,
      productTop3ChangeValue: 0,
      contactTop1Total: 42336,
      contactTop2Total: 0,
      contactTop3Total: 0,
      contactTop1Id: 58278,
      contactTop2Id: 0,
      contactTop3Id: 0,
      contactOtherTotal: 0,
      contactTop1ChangeValue: 1000,
      contactTop2ChangeValue: 0,
      contactTop3ChangeValue: 0,
      accountTop1Id: 88,
      accountTop2Id: 0,
      accountTop3Id: 0,
      accountTop1Total: 42336,
      accountTop2Total: 0,
      accountTop3Total: 0,
      accountOtherTotal: 0,
      accountTop1ChangeValue: 1000,
      accountTop2ChangeValue: 0,
      accountTop3ChangeValue: 0,
    },
    expense: {
      total: 40674,
      changeVaue: 1000,
      changeFormType: 3,
      productTop1Id: 31720,
      productTop2Id: 0,
      productTop3Id: 0,
      productTop1Total: 28224,
      productTop2Total: 0,
      productTop3Total: 0,
      productOtherTotal: 12450,
      productTop1ChangeValue: 1000,
      productTop2ChangeValue: 0,
      productTop3ChangeValue: 0,
      contactTop1Total: 28224,
      contactTop2Total: 11604,
      contactTop3Total: 846,
      contactTop1Id: 58278,
      contactTop2Id: 58279,
      contactTop3Id: 58282,
      contactOtherTotal: 0,
      contactTop1ChangeValue: 1000,
      contactTop2ChangeValue: 1000,
      contactTop3ChangeValue: 1000,
      accountTop1Id: 101,
      accountTop2Id: 148,
      accountTop3Id: 160,
      accountTop1Total: 28224,
      accountTop2Total: 7100,
      accountTop3Total: 4504,
      accountOtherTotal: 846,
      accountTop1ChangeValue: 1000,
      accountTop2ChangeValue: 1000,
      accountTop3ChangeValue: 1000,
      accountExpenseTypeTop1Id: 1,
      accountExpenseTypeTop2Id: 3,
      accountExpenseTypeTop3Id: 2,
      accountExpenseTypeTop1Total: 28224,
      accountExpenseTypeTop2Total: 11604,
      accountExpenseTypeTop3Total: 846,
      accountExpenseTypeOtherTotal: 0,
      accountExpenseTypeTop1ChangeValue: 1000,
      accountExpenseTypeTop2ChangeValue: 1000,
      accountExpenseTypeTop3ChangeValue: 1000,
    },
  };
  const thisYear = {
    customDashBoardId: 64,
    allocationId: 217,
    customDashboardGroup: {
      id: "60c1c8e30e70293c942c67d2",
      merchantId: 2788,
      createdDateTime: "2021-06-10T08:10:11.885Z",
      createdUserId: 2867,
      customDashboardId: 64,
      allocationId: 217,
      allocationItemGroupList: [
        {
          name: "ร้านรัชดาภิเษก",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 478,
            },
          ],
        },
      ],
    },
    dashboardSelectOptionType: 3,
    fromDate: "2021-01-01T00:00:00",
    toDate: "2021-12-31T00:00:00",
    revenueSummaryTotal: 560782,
    expenseSummaryTotal: 526633.5,
    profitSummaryTotal: 34148.5,
    summaryDetail: {
      revenueSummaryTotal: 560782,
      expenseSummaryTotal: 526633.5,
      profitSummaryTotal: 34148.5,
      changeFormType: 5,
      revenueSummaryChangeValue: -0.11,
      expenseSummaryChangeValue: -0.11,
      profitSummaryChangeValue: -0.12,
      allocationSummaryItemDetailList: [
        {
          date: "2021-01-01T00:00:00",
          revenueTotal: 40824,
          expenseTotal: 40032.5,
          profitTotal: 791.5,
          revenueChangeValue: 4.42,
          expenseChangeValue: 2.26,
          profitChangeValue: 1651.96,
          changeFormType: 3,
        },
        {
          date: "2021-02-01T00:00:00",
          revenueTotal: 43200,
          expenseTotal: 41627,
          profitTotal: 1573,
          revenueChangeValue: 5.82,
          expenseChangeValue: 3.98,
          profitChangeValue: 98.74,
          changeFormType: 3,
        },
        {
          date: "2021-03-01T00:00:00",
          revenueTotal: 21600,
          expenseTotal: 26332,
          profitTotal: -4732,
          revenueChangeValue: -50,
          expenseChangeValue: -36.74,
          profitChangeValue: -400.83,
          changeFormType: 3,
        },
        {
          date: "2021-04-01T00:00:00",
          revenueTotal: 69552,
          expenseTotal: 59868,
          profitTotal: 9684,
          revenueChangeValue: 222,
          expenseChangeValue: 127.36,
          profitChangeValue: 304.65,
          changeFormType: 3,
        },
        {
          date: "2021-05-01T00:00:00",
          revenueTotal: 49680,
          expenseTotal: 46703,
          profitTotal: 2977,
          revenueChangeValue: -28.57,
          expenseChangeValue: -21.99,
          profitChangeValue: -69.26,
          changeFormType: 3,
        },
        {
          date: "2021-06-01T00:00:00",
          revenueTotal: 28944,
          expenseTotal: 32074,
          profitTotal: -3130,
          revenueChangeValue: -41.74,
          expenseChangeValue: -31.32,
          profitChangeValue: -205.14,
          changeFormType: 3,
        },
        {
          date: "2021-07-01T00:00:00",
          revenueTotal: 40824,
          expenseTotal: 40435,
          profitTotal: 389,
          revenueChangeValue: 41.04,
          expenseChangeValue: 26.07,
          profitChangeValue: 112.43,
          changeFormType: 3,
        },
        {
          date: "2021-08-01T00:00:00",
          revenueTotal: 75816,
          expenseTotal: 63891,
          profitTotal: 11925,
          revenueChangeValue: 85.71,
          expenseChangeValue: 58.01,
          profitChangeValue: 2965.55,
          changeFormType: 3,
        },
        {
          date: "2021-09-01T00:00:00",
          revenueTotal: 47952,
          expenseTotal: 45628,
          profitTotal: 2324,
          revenueChangeValue: -36.75,
          expenseChangeValue: -28.58,
          profitChangeValue: -80.51,
          changeFormType: 3,
        },
        {
          date: "2021-10-01T00:00:00",
          revenueTotal: 52056,
          expenseTotal: 47145,
          profitTotal: 4911,
          revenueChangeValue: 8.56,
          expenseChangeValue: 3.32,
          profitChangeValue: 111.32,
          changeFormType: 3,
        },
        {
          date: "2021-11-01T00:00:00",
          revenueTotal: 42336,
          expenseTotal: 40674,
          profitTotal: 1662,
          revenueChangeValue: -18.67,
          expenseChangeValue: -13.73,
          profitChangeValue: -66.16,
          changeFormType: 3,
        },
        {
          date: "2021-12-01T00:00:00",
          revenueTotal: 47998,
          expenseTotal: 42224,
          profitTotal: 5774,
          revenueChangeValue: 13.37,
          expenseChangeValue: 3.81,
          profitChangeValue: 247.41,
          changeFormType: 3,
        },
      ],
    },
    profitLossDetail: {
      revenueTotal: 560782,
      costOfSalesAndServicesTotal: 371520,
      grossProfitLossTotal: 189262,
      sellingExpensesTotal: 11212,
      administrativeExpenseTotal: 142213,
      otherExpensesTotal: 1688.5,
      netOperatingProfitLossBeforeInterestAndTaxTotal: 34148.5,
      interestExpenseTotal: 0,
      incomeTaxTotal: 0,
      profitTotal: 34148.5,
      allocationAccountList: [
        {
          accountId: 101,
          total: 371520,
        },
        {
          accountId: 88,
          total: 560782,
        },
        {
          accountId: 108,
          total: 11212,
        },
        {
          accountId: 201,
          total: 1688.5,
        },
        {
          accountId: 160,
          total: 57913,
        },
        {
          accountId: 148,
          total: 84300,
        },
      ],
    },
    revenue: {
      total: 560782,
      changeVaue: -0.11,
      changeFormType: 5,
      productTop1Id: 31720,
      productTop2Id: 0,
      productTop3Id: 0,
      productTop1Total: 560782,
      productTop2Total: 0,
      productTop3Total: 0,
      productOtherTotal: 0,
      productTop1ChangeValue: -0.11,
      productTop2ChangeValue: 0,
      productTop3ChangeValue: 0,
      contactTop1Total: 560782,
      contactTop2Total: 0,
      contactTop3Total: 0,
      contactTop1Id: 58278,
      contactTop2Id: 0,
      contactTop3Id: 0,
      contactOtherTotal: 0,
      contactTop1ChangeValue: -0.11,
      contactTop2ChangeValue: 0,
      contactTop3ChangeValue: 0,
      accountTop1Id: 88,
      accountTop2Id: 0,
      accountTop3Id: 0,
      accountTop1Total: 560782,
      accountTop2Total: 0,
      accountTop3Total: 0,
      accountOtherTotal: 0,
      accountTop1ChangeValue: -0.11,
      accountTop2ChangeValue: 0,
      accountTop3ChangeValue: 0,
    },
    expense: {
      total: 526633.5,
      changeVaue: -0.11,
      changeFormType: 5,
      productTop1Id: 31720,
      productTop2Id: 0,
      productTop3Id: 0,
      productTop1Total: 371520,
      productTop2Total: 0,
      productTop3Total: 0,
      productOtherTotal: 155113.5,
      productTop1ChangeValue: -0.73,
      productTop2ChangeValue: 0,
      productTop3ChangeValue: 0,
      contactTop1Total: 371520,
      contactTop2Total: 142213,
      contactTop3Total: 12900.5,
      contactTop1Id: 58278,
      contactTop2Id: 58279,
      contactTop3Id: 58282,
      contactOtherTotal: 0,
      contactTop1ChangeValue: -0.73,
      contactTop2ChangeValue: 2.56,
      contactTop3ChangeValue: -9.65,
      accountTop1Id: 101,
      accountTop2Id: 148,
      accountTop3Id: 160,
      accountTop1Total: 371520,
      accountTop2Total: 84300,
      accountTop3Total: 57913,
      accountOtherTotal: 12900.5,
      accountTop1ChangeValue: -0.73,
      accountTop2ChangeValue: 5.24,
      accountTop3ChangeValue: -1.1,
      accountExpenseTypeTop1Id: 1,
      accountExpenseTypeTop2Id: 3,
      accountExpenseTypeTop3Id: 2,
      accountExpenseTypeTop1Total: 371520,
      accountExpenseTypeTop2Total: 142213,
      accountExpenseTypeTop3Total: 11212,
      accountExpenseTypeOtherTotal: 1688.5,
      accountExpenseTypeTop1ChangeValue: -0.73,
      accountExpenseTypeTop2ChangeValue: 2.56,
      accountExpenseTypeTop3ChangeValue: 14.02,
    },
  };
  const lastYear = {
    customDashBoardId: 64,
    allocationId: 217,
    customDashboardGroup: {
      id: "60c1c8e30e70293c942c67d2",
      merchantId: 2788,
      createdDateTime: "2021-06-10T08:10:11.885Z",
      createdUserId: 2867,
      customDashboardId: 64,
      allocationId: 217,
      allocationItemGroupList: [
        {
          name: "ร้านรัชดาภิเษก",
          allocationItemGroupType: 1,
          allocationItemList: [
            {
              allocationItemId: 478,
            },
          ],
        },
      ],
    },
    dashboardSelectOptionType: 4,
    fromDate: "2020-01-01T00:00:00",
    toDate: "2020-12-31T00:00:00",
    revenueSummaryTotal: 561384,
    expenseSummaryTotal: 527194,
    profitSummaryTotal: 34190,
    summaryDetail: {
      revenueSummaryTotal: 561384,
      expenseSummaryTotal: 527194,
      profitSummaryTotal: 34190,
      changeFormType: 5,
      revenueSummaryChangeValue: 1000,
      expenseSummaryChangeValue: 1000,
      profitSummaryChangeValue: 1000,
      allocationSummaryItemDetailList: [
        {
          date: "2020-01-01T00:00:00",
          revenueTotal: 21600,
          expenseTotal: 26428,
          profitTotal: -4828,
          revenueChangeValue: 1000,
          expenseChangeValue: 1000,
          profitChangeValue: 1000,
          changeFormType: 3,
        },
        {
          date: "2020-02-01T00:00:00",
          revenueTotal: 40824,
          expenseTotal: 39671,
          profitTotal: 1153,
          revenueChangeValue: 89,
          expenseChangeValue: 50.11,
          profitChangeValue: 123.88,
          changeFormType: 3,
        },
        {
          date: "2020-03-01T00:00:00",
          revenueTotal: 52056,
          expenseTotal: 48324.5,
          profitTotal: 3731.5,
          revenueChangeValue: 27.51,
          expenseChangeValue: 21.81,
          profitChangeValue: 223.63,
          changeFormType: 3,
        },
        {
          date: "2020-04-01T00:00:00",
          revenueTotal: 75816,
          expenseTotal: 63380,
          profitTotal: 12436,
          revenueChangeValue: 45.64,
          expenseChangeValue: 31.16,
          profitChangeValue: 233.27,
          changeFormType: 3,
        },
        {
          date: "2020-05-01T00:00:00",
          revenueTotal: 21600,
          expenseTotal: 27037.5,
          profitTotal: -5437.5,
          revenueChangeValue: -71.51,
          expenseChangeValue: -57.34,
          profitChangeValue: -143.72,
          changeFormType: 3,
        },
        {
          date: "2020-06-01T00:00:00",
          revenueTotal: 40824,
          expenseTotal: 40322,
          profitTotal: 502,
          revenueChangeValue: 89,
          expenseChangeValue: 49.13,
          profitChangeValue: 109.23,
          changeFormType: 3,
        },
        {
          date: "2020-07-01T00:00:00",
          revenueTotal: 47952,
          expenseTotal: 45257,
          profitTotal: 2695,
          revenueChangeValue: 17.46,
          expenseChangeValue: 12.24,
          profitChangeValue: 436.85,
          changeFormType: 3,
        },
        {
          date: "2020-08-01T00:00:00",
          revenueTotal: 52056,
          expenseTotal: 47644,
          profitTotal: 4412,
          revenueChangeValue: 8.56,
          expenseChangeValue: 5.27,
          profitChangeValue: 63.71,
          changeFormType: 3,
        },
        {
          date: "2020-09-01T00:00:00",
          revenueTotal: 69552,
          expenseTotal: 58048,
          profitTotal: 11504,
          revenueChangeValue: 33.61,
          expenseChangeValue: 21.84,
          profitChangeValue: 160.74,
          changeFormType: 3,
        },
        {
          date: "2020-10-01T00:00:00",
          revenueTotal: 47952,
          expenseTotal: 44891,
          profitTotal: 3061,
          revenueChangeValue: -31.06,
          expenseChangeValue: -22.67,
          profitChangeValue: -73.39,
          changeFormType: 3,
        },
        {
          date: "2020-11-01T00:00:00",
          revenueTotal: 52056,
          expenseTotal: 47044,
          profitTotal: 5012,
          revenueChangeValue: 8.56,
          expenseChangeValue: 4.8,
          profitChangeValue: 63.74,
          changeFormType: 3,
        },
        {
          date: "2020-12-01T00:00:00",
          revenueTotal: 39096,
          expenseTotal: 39147,
          profitTotal: -51,
          revenueChangeValue: -24.9,
          expenseChangeValue: -16.79,
          profitChangeValue: -101.02,
          changeFormType: 3,
        },
      ],
    },
    profitLossDetail: {
      revenueTotal: 561384,
      costOfSalesAndServicesTotal: 374256,
      grossProfitLossTotal: 187128,
      sellingExpensesTotal: 9833,
      administrativeExpenseTotal: 138659,
      otherExpensesTotal: 4446,
      netOperatingProfitLossBeforeInterestAndTaxTotal: 34190,
      interestExpenseTotal: 0,
      incomeTaxTotal: 0,
      profitTotal: 34190,
      allocationAccountList: [
        {
          accountId: 160,
          total: 58559,
        },
        {
          accountId: 148,
          total: 80100,
        },
        {
          accountId: 108,
          total: 9833,
        },
        {
          accountId: 201,
          total: 4446,
        },
        {
          accountId: 101,
          total: 374256,
        },
        {
          accountId: 88,
          total: 561384,
        },
      ],
    },
    revenue: {
      total: 561384,
      changeVaue: 1000,
      changeFormType: 5,
      productTop1Id: 31720,
      productTop2Id: 0,
      productTop3Id: 0,
      productTop1Total: 561384,
      productTop2Total: 0,
      productTop3Total: 0,
      productOtherTotal: 0,
      productTop1ChangeValue: 1000,
      productTop2ChangeValue: 0,
      productTop3ChangeValue: 0,
      contactTop1Total: 561384,
      contactTop2Total: 0,
      contactTop3Total: 0,
      contactTop1Id: 58278,
      contactTop2Id: 0,
      contactTop3Id: 0,
      contactOtherTotal: 0,
      contactTop1ChangeValue: 1000,
      contactTop2ChangeValue: 0,
      contactTop3ChangeValue: 0,
      accountTop1Id: 88,
      accountTop2Id: 0,
      accountTop3Id: 0,
      accountTop1Total: 561384,
      accountTop2Total: 0,
      accountTop3Total: 0,
      accountOtherTotal: 0,
      accountTop1ChangeValue: 1000,
      accountTop2ChangeValue: 0,
      accountTop3ChangeValue: 0,
    },
    expense: {
      total: 527194,
      changeVaue: 1000,
      changeFormType: 5,
      productTop1Id: 31720,
      productTop2Id: 0,
      productTop3Id: 0,
      productTop1Total: 374256,
      productTop2Total: 0,
      productTop3Total: 0,
      productOtherTotal: 152938,
      productTop1ChangeValue: 1000,
      productTop2ChangeValue: 0,
      productTop3ChangeValue: 0,
      contactTop1Total: 374256,
      contactTop2Total: 138659,
      contactTop3Total: 14279,
      contactTop1Id: 58278,
      contactTop2Id: 58279,
      contactTop3Id: 58282,
      contactOtherTotal: 0,
      contactTop1ChangeValue: 1000,
      contactTop2ChangeValue: 1000,
      contactTop3ChangeValue: 1000,
      accountTop1Id: 101,
      accountTop2Id: 148,
      accountTop3Id: 160,
      accountTop1Total: 374256,
      accountTop2Total: 80100,
      accountTop3Total: 58559,
      accountOtherTotal: 14279,
      accountTop1ChangeValue: 1000,
      accountTop2ChangeValue: 1000,
      accountTop3ChangeValue: 1000,
      accountExpenseTypeTop1Id: 1,
      accountExpenseTypeTop2Id: 3,
      accountExpenseTypeTop3Id: 2,
      accountExpenseTypeTop1Total: 374256,
      accountExpenseTypeTop2Total: 138659,
      accountExpenseTypeTop3Total: 9833,
      accountExpenseTypeOtherTotal: 4446,
      accountExpenseTypeTop1ChangeValue: 1000,
      accountExpenseTypeTop2ChangeValue: 1000,
      accountExpenseTypeTop3ChangeValue: 1000,
    },
  };

  let month: any = null;
  let year: any = null;
  let date: any = null;

  switch (dashboardSelectOptionType) {
    case DashboardSelectOptionType.ThisMonth:
      month = new Date().getMonth();
      year = new Date().getFullYear();

      thisMonth.fromDate = new Date(year, month, 1).ToDateJsonString();
      thisMonth.toDate = new Date(year, month + 1, 0).ToDateJsonString();

      thisMonth.summaryDetail.allocationSummaryItemDetailList.forEach((element) => {
        date = new Date(element.date).getDate();
        element.date = new Date(year, month, date).ToDateJsonString();
      });
      return thisMonth;
      break;
    case DashboardSelectOptionType.LastMonth:
      month = new Date().getMonth();
      year = new Date().getFullYear();

      thisMonth.fromDate = new Date(year, month - 1, 1).ToDateJsonString();
      thisMonth.toDate = new Date(year, month, 0).ToDateJsonString();

      thisMonth.summaryDetail.allocationSummaryItemDetailList.forEach((element) => {
        date = new Date(element.date).getDate();
        element.date = new Date(year, month - 1, date).ToDateJsonString();
      });
      return lastMonth;
      break;
    case DashboardSelectOptionType.ThisYear:
      return thisYear;
      break;
    case DashboardSelectOptionType.LastYear:
      return lastYear;
      break;
  }
}
